export { default } from "./FirstCrmConnectionMessage";
